export const dadosIniciais = {
  cpf: "",
  cns: "",
  email: "",
  nome: "",
  nomeMae: "",
  nomeSocial: "",
  sexo: "",
  naturalidade: 23,
  dataNascimento: "",
  raca: "",
  estadoCivil: "",
  religiao: "",
  profissao: "",
  escolaridade: "",
  lateralidade: "",
  tipoTrabalho: "",
  ultimasAtividades: "",
  condicaoAtual: "",
  tempoTrabalho: "",
  estadoNascimento: "",
  municipioNascimento: "",
  identidadeGenero: "",
  cep: "",
  uf: "",
  municipio: "",
  ibge: "",
  bairro: "",
  logradouro: "",
  numero: "",
  complemento: "",
  telefones: [{ id: 1, telefone: "", nome: "" }],
};
